import React from "react";
import { Link } from "react-router-dom";

const Nav = () => {
  return (
    <div className="main-menu text-center">
      <nav>
        <ul className="main-menu__list">
          <li className="current">
            <Link to={process.env.PUBLIC_URL + `/`}>Početna</Link>
          </li>
          <li>
            <Link to={process.env.PUBLIC_URL + `/`}>O nama</Link>
          </li>
          <li>
            <Link to={process.env.PUBLIC_URL + `/`}>Usluge</Link>
          </li>
          <li>
            <Link to={process.env.PUBLIC_URL + `/`}>Naši radovi</Link>
          </li>
          <li>
            <Link to={process.env.PUBLIC_URL + `/`}>Reference</Link>
          </li>
          <li>
            <Link to={process.env.PUBLIC_URL + `/`}>Kontakt</Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Nav;
